// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__22rAk","spot2-animation":"Loading_spot2-animation__IEI52"};